import React, { useState, useEffect } from 'react';
import ProductTable from "../../../components/tables/ProductTable";
import axios from "axios";
import {API} from "../../../config";
import {getAdminUserCatalog} from "../../../store/action/user";
import {updateCategories} from "../../../store/action/catalog";
import {
    createProductByAdmin,
    updateProductByAdmin,
    deleteProductByAdmin,
    updateProductImage
} from "../../../store/action/product";
import {isContainNumber, isContainText} from "../../../services/helpers/validator";
import ProductForm from "../../../components/forms/ProductForm";
import Modal from "../../../components/molecules/Modal";

const AdminUserProductList = ({user,token}) => {
    const [ show, setShow ] = useState({
        modal: false,
        modalType: ''
    });
    let catalogInitial = {
        addressName:'',
        addressPhone:'',
        addressDetails:'',
        addressCoordinate:{},
        addressNote:'',
        category:'',
        categories:[],
        catalogId: '',
        description: '',
        link: '-',
        organizationId: '',
        products: [],
        productId:'',
        productName: '',
        productPrice: '',
        productDetails: '',
        productImage: '',
        productLength:0,
        productHeight:0,
        productWidth:0,
        productWeight:0,
        productCategory:'',
        productSku:'',
        productStock:0,
        productStatus: 'active',
        subtitle: '',
        status: '',
        style: {},
        title: '',
        userId: ''
    };
    const [ catalog, setCatalog ] = useState(catalogInitial);
    const [ newCatalog, setNewCatalog ] = useState(catalogInitial);
    const [ categories, setCategories ] = useState([]);
    const [ values, setValues] = useState(({
        error:false,
        info:'',
        pageLoading:true,
        productSubmitLoading:false,
        progress:0,
        success:false
    }));

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        setValues({...values, pageLoading:true});
        try {
            const resCat = await getAdminUserCatalog(user.id, token);
            if (resCat.success) {
                setCatalogResponse(resCat)
            }
            setValues({
                ...values,
                pageLoading:false
            })
        } catch (e) {
            console.log (e);
            alert(`Maaf. Gagal ambil data katalog.`)
            setValues({
                ...values,
                pageLoading:false
            })
        }
    };

    const setCatalogResponse = (resCat) => {
        const products = resCat.catalog.products.reduce((r,i) => {
            r.push({
                ...i,
                stockUpdate:i.quantity
            });
            return r
        },[]);

        setCategories(resCat.catalog.categories);
        setCatalog({
            ...catalog,
            addressName:resCat.catalog.address.name,
            addressPhone:resCat.catalog.address.phone,
            addressDetails:resCat.catalog.address.location,
            addressCoordinate:resCat.catalog.address.coordinate,
            addressNote:resCat.catalog.address.note,
            catalogId: resCat.catalog._id,
            categories: resCat.catalog.categories,
            createdAt: resCat.catalog.createdAt,
            description: resCat.catalog.description,
            link: resCat.catalog.link,
            organizationId: resCat.catalog.organizationId,
            products: products,
            status: resCat.catalog.status,
            subtitle: resCat.catalog.subtitle,
            style: resCat.catalog.style,
            title: resCat.catalog.title,
            updatedAt: resCat.catalog.updatedAt,
            userId: resCat.catalog.userId
        });
        setNewCatalog({
            ...newCatalog,
            categories: resCat.catalog.categories,
            subtitle: resCat.catalog.subtitle,
            title: resCat.catalog.title,
            style: resCat.catalog.style,
            addressName:resCat.catalog.address.name,
            addressPhone:resCat.catalog.address.phone,
            addressDetails:resCat.catalog.address.location,
            addressCoordinate:resCat.catalog.address.coordinate,
            addressNote:resCat.catalog.address.note,
            productCategory: resCat.catalog.categories[0]
        });
    };

    const handleModalClose = () => {
        setShow({
            ...modal,
            modal:false
        });
        setNewCatalog({
            ...newCatalog,
            productName: '',
            productPrice: '',
            productDetails: '',
            productSku: '',
            productImage: '',
            productLength:0,
            productHeight:0,
            productWidth:0,
            productWeight:0,
            productCategory:'',
        })
    };

    const handleModalShow = (type) => {
        setShow({
            modal:true,
            modalType: type
        });
    };

    const handleProductChange = name => e => {
        const value = e.target.value;
        setNewCatalog({ ...newCatalog, [name]: value });
        setValues({...values, error: ''})
    };

    const handleCategoryChange = name => e => {
        const value = e.target.value;
        setNewCatalog({ ...newCatalog, [name]: value });
        setValues({...values, error: ''})
    };

    const onEditProduct = (product) => {
        handleModalShow('editProduct');
        setNewCatalog({
            ...newCatalog,
            ...product
        })
    };

    const onStatusProduct = async (product) => {
        let data = {
            productId: product.productId,
            name: product.productName,
            sku: product.productSku,
            details: product.productDetails,
            category: product.productCategory,
            image: product.productImage,
            length: product.productLength,
            width: product.productWidth,
            height: product.productHeight,
            weight: product.productWeight,
            price: product.productPrice,
            stock: product.productStock,
            status: product.productStatus
        };
        let resProd = await updateProductByAdmin(token, user.id, data);
        try {
            if (resProd.success) {
                setCatalogResponse(resProd)
            } else {
                setValues({
                    ...values,
                    info:'',
                    error: resProd.error,
                    productSubmitLoading: false
                });
                alert("Produk gagal diupdate.");
            }
        } catch (e) {
            console.log (e);
            setValues({
                ...values,
                info:'',
                error: resProd.error,
                productSubmitLoading: false
            });
            alert("Produk gagal diupdate.");
        }
    };

    const onSelectImageProduct = async (e) => {
        const data = e.target.files[0];
        const res = await updateProductImage(token, data);
        if(res.success) {
            alert("Foto produk telah diupdate");
            setNewCatalog({
                ...newCatalog,
                productImage: res.image
            })
        } else {
            alert("Foto produk gagal diupadte. Coba ulangi lagi yuk!")
        }
    };

    const onAddCategory = async () => {
        if (!newCatalog.category) {
            alert("Kategori masih kosong");
            return
        }
        let copyCategory = newCatalog.category;
        let copyCategories = newCatalog.categories;
        copyCategories.push(copyCategory);

        setCatalog({
            ...catalog,
            categories: []
        });

        setNewCatalog({
            ...newCatalog,
            category: '',
            categories: copyCategories,
            productCategory: newCatalog.category
        })
    };

    const onRemoveCategory = async (category) => {
        let copyCategories = newCatalog.categories;
        let filteredCategories = copyCategories.filter(i => i !== category);
        setNewCatalog({
            ...newCatalog,
            category: '',
            categories: filteredCategories
        })
    };

    const onSubmitNewCategories = async () => {
        const resCat = await updateCategories(token, catalog.catalogId, {categories: newCatalog.categories});
        if (resCat.success){
            alert("Kategori berhasil disimpan");
            window.location.reload()
        } else {
            alert("Gagal update kategori")
        }
    };

    const onEditCategory = async () => {
        setNewCatalog({
            ...newCatalog,
            productCategory: catalog.categories[0]
        })
    };

    const addCatalog = async () => {
        try {
            const res = await axios.post(`${API}/v1/admin/catalogs`, { user_id: user.id}, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
            if(res.data.success) {
                alert(res.data.message);
                window.location.reload()
            } else {
                alert(res.data.error);
            }
        } catch (e) {
            console.log (e);
            return alert(e.message)
        }
    };

    const onAddStock = async (idx,sku) => {
        try {
            const res = await axios.post(`${API}/v1/stock_movements/sku`, {sku}, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
            if(res.data.success) {
                let products = catalog.products;
                products[idx].stockUpdate = res.data.stock;
                setCatalog({...catalog, products});
            } else {
                alert(res.data.error);
            }
        } catch (e) {
            alert(e.response.data.error)
        }
    };

    const onRemoveStock = async (idx,sku) => {
        try {
            const res = await axios.post(`${API}/v1/stock_movements/sku/${sku}`, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
            if(res.data.success) {
                let products = catalog.products;
                products[idx].stockUpdate = res.data.stock;
                setCatalog({...catalog, products});
            } else {
                alert(res.data.error);
            }
        } catch (e) {
            alert(e.response.data.error)
        }
    };

    const onRestoreStock = async (idx,sku) => {
        try {
            const res = await axios.post(`${API}/v1/stock_movements/sku/${sku}/restore`, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
            if(res.data.success) {
                let products = catalog.products;
                products[idx].stockUpdate = res.data.stock;
                setCatalog({...catalog, products});
            } else {
                alert(res.data.error);
            }
        } catch (e) {
            alert(e.response.data.error)
        }
    };

    const onSubmitProduct = async (type) => {
        let resProd;
        const checkName = await isContainText('Nama barang',newCatalog.productName);
        if (!checkName .success) return setValues({...values, error: checkName.message});
        const checkPrice = await isContainText('Harga barang',newCatalog.productPrice);
        if (!checkPrice .success) return setValues({...values, error: checkPrice.message});
        const checkStock = await isContainNumber('Stok barang',newCatalog.productStock);
        if (!checkStock .success) return setValues({...values, error: checkStock.message});
        if (!newCatalog.productLength || !newCatalog.productWidth || !newCatalog.productHeight || !newCatalog.productWeight) {
            return setValues({...values, error: 'Dimensi atau berat barang masih kosong. Mohon diisi.'})
        }

        if (type === 'new') {
            setValues({
                ...values,
                info:'Membuat produk baru...',
                productSubmitLoading: true
            });
        } else {
            setValues({
                ...values,
                info:'Menyimpan editan produk...',
                productSubmitLoading: true
            });
        }

        try {
            let data = {
                productId: newCatalog.productId,
                name: newCatalog.productName,
                sku: newCatalog.productSku,
                details: newCatalog.productDetails,
                category: newCatalog.productCategory,
                image: newCatalog.productImage,
                length: newCatalog.productLength,
                width: newCatalog.productWidth,
                height: newCatalog.productHeight,
                weight: newCatalog.productWeight,
                price: newCatalog.productPrice,
                stock: newCatalog.productStock,
                status: newCatalog.productStatus
            };
            if (type === 'new') {
                resProd = await createProductByAdmin(token, user.id, newCatalog);
            } else {
                resProd = await updateProductByAdmin(token, user.id, data)
            }

            if (resProd.success) {
                if (type === 'new') {
                    alert("Produk berhasil dibuat.");
                } else {
                    alert("Produk berhasil diedit.");
                }
                window.location.reload()
            } else {
                setValues({
                    ...values,
                    info:'',
                    error: resProd.error,
                    productSubmitLoading: false
                });
                alert("Produk gagal dibuat.");
            }
        } catch (e) {
            console.log (e);
            setValues({
                ...values,
                info:'',
                error: resProd.error,
                productSubmitLoading: false
            });
            alert("Produk gagal dibuat.");
        }
    };

    const onRemoveProduct = async (productId) => {
        try {
            let resProd;
            if(window.confirm('Kamu yakin mau delete produk?')){
                resProd = await deleteProductByAdmin(token, user.id,productId);
                if (resProd.success) {
                    alert("Produk berhasil didelete.");
                    window.location.reload()
                } else {
                    alert(resProd.error);
                }
            }

        } catch (e) {
            console.log (e);
            alert("Produk gagal didelete.");
        }
    };

    const showError = () => (
        <div
            className="alert alert-danger mb-0"
            style={{display: values.error ? '' : 'none'}}
        >
            { values.error }
        </div>
    );

    const showInfo = () => (
        <div
            className="alert alert-info mb-0"
            style={{display: values.info ? '' : 'none'}}
        >
            { values.info }
        </div>
    );

    const modal = () => {
        let body, title, bText, bClick, size, type, lbClick, rbClick;
        if (show.modalType === 'editCategory') {
            lbClick = () => handleModalShow('addProduct');
            rbClick = () => onSubmitNewCategories();
            type = 'yesno';
            title = `Edit Kategori`;
            body = (
                <div className="p-4">
                    <h6>Kategori Katalog Saya</h6>
                    <div>
                        {
                            newCatalog.categories.map((i,idx) => (
                                <div key={idx} className="pl-4 py-1 d-flex justify-content-between bg-lighter mb-1">
                                    <b className="pt-1">{i}</b>
                                    <a onClick={() => onRemoveCategory(i)}
                                       className="action-item mr-2"
                                       data-toggle="tooltip"
                                       title="Remove">
                                        <i className="fas fa-times"></i>
                                    </a>
                                </div>
                            ))
                        }
                    </div>
                    <div className="input-group mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Nama Kategori"
                            onChange={handleCategoryChange('category')}
                            value={newCatalog.category}
                        />
                        <div className="input-group-append">
                            <button
                                onClick={onAddCategory}
                                className="btn btn-outline-primary"
                                type="button"
                            >
                                Tambah
                            </button>
                        </div>
                    </div>
                </div>
            )
        } else if (show.modalType === 'addProduct') {
            lbClick = () => handleModalClose();
            type = 'yesno';
            size = 'md';
            // catcatcat
            if (catalog.categories.length === 0 ) {
                rbClick = () => onSubmitNewCategories();
                title = `Tambah Kategori`;
                body = (
                    <div className="p-4">
                        <h6>Kategori produk masih kosong. Tambah dulu ya!</h6>
                        <div>
                            {
                                newCatalog.categories.map((i,idx) => (
                                    <div key={idx} className="pl-4 py-1 d-flex justify-content-between bg-lighter mb-1">
                                        <b className="pt-1">{i}</b>
                                        <a onClick={() => onRemoveCategory(i)}
                                           className="action-item mr-2"
                                           data-toggle="tooltip"
                                           title="Remove">
                                            <i className="fas fa-times"></i>
                                        </a>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="input-group mb-3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Nama Kategori"
                                onChange={handleCategoryChange('category')}
                                value={newCatalog.category}
                            />
                            <div className="input-group-append">
                                <button
                                    onClick={() => onAddCategory()}
                                    className="btn btn-outline-primary"
                                    type="button"
                                >
                                    Tambah
                                </button>
                            </div>
                        </div>
                    </div>
                )
            } else {
                rbClick = () => onSubmitProduct('new');
                lbClick = () => handleModalClose();
                type = 'yesno';
                size = 'lg';
                title = `Tambah Produk`;
                body = (
                    <ProductForm
                        className="p-4"
                        loading={values.productSubmitLoading}
                        handleChange={handleProductChange}
                        categories={categories}
                        onClickEditCategories={() => handleModalShow('editCategory')}
                        onProductImageSelect={onSelectImageProduct}
                        values={newCatalog}
                    />
                )
            }
        } else if (show.modalType === 'editProduct') {
            type = 'yesno';
            size = 'lg';
            lbClick = () => handleModalClose();
            rbClick = () => onSubmitProduct('edit');
            title = `Edit Produk`;
            body = (
                <ProductForm
                    className="p-4"
                    loading={values.productSubmitLoading}
                    handleChange={handleProductChange}
                    categories={categories}
                    onClickEditCategory={onEditCategory}
                    onClickEditCategories={() => handleModalShow('editCategory')}
                    onProductImageSelect={onSelectImageProduct}
                    values={newCatalog}
                />
            )
        } else {
            body = (
                <div>Loading...</div>
            )
        }

        return (
            <Modal
                bodyClassName="p-0"
                show={show.modal}
                size={size}
                onHide={handleModalClose}
                title={title}
                type={type}
                buttons
                footerStyle={{justifyContent:'flex-end'}}
                lbText="Kembali"
                lbClick={lbClick}
                rbText="Simpan"
                rbClick={rbClick}
                bText={bText}
                bClick={bClick}
            >
                { showError() }
                { showInfo() }
                { body }
            </Modal>
        )
    };
    let catalogView;
    if (catalog.catalogId) {
        catalogView = (
            <div>
                <ProductTable
                    data={catalog.products}
                    categories={catalog.categories}
                    loading={values.pageLoading}
                    onClickEditProduct={onEditProduct}
                    onClickRemoveProduct={onRemoveProduct}
                    onClickProductStatus={onStatusProduct}
                    onAddStock={onAddStock}
                    onRemoveStock={onRemoveStock}
                    onRestoreStock={onRestoreStock}
                />
            </div>

        )
    } else if (values.pageLoading) {
        catalogView = (
            <div className="p-4">loading...</div>
        )
    } else {
        catalogView = (
            <div className="text-center p-5">
                <h5>Customer belum memiliki katalog</h5>
                <button
                    onClick={addCatalog}
                    className="btn btn-primary col-3 mt-2">
                    Buat Katalog
                </button>
            </div>
        )
    }

    return (
        <div>
            <div className="bg-white rounded shadow">
                { modal() }
                <div className="px-4 pt-4 ">
                    { catalog.catalogId ?
                        <div className="d-flex justify-content-between">
                            <h5>List Pesanan </h5>
                            <button
                                className="btn btn-primary ml-2"
                                onClick={() => handleModalShow('addProduct')}
                            >
                                Tambah Produk
                            </button>
                        </div> : ''
                    }
                </div>
                { catalogView }
            </div>
        </div>
    )
};


export default AdminUserProductList;
